import { createAction } from 'typesafe-actions';

export const setBusinessAppointmentsAction = createAction('filters/setBusinessAppointments')<Array<number>>();
